import clsx from "clsx";

/** A small labelled figure used in the classification detail cells. */
export function DetailStat({
  label,
  value,
  className,
}: {
  label: string;
  value: React.ReactNode;
  className?: string;
}) {
  return (
    <span className="inline-flex items-baseline gap-1">
      <span className="text-[10px] uppercase tracking-wide text-gray-500 dark:text-gray-400">
        {label}
      </span>
      <span className={clsx("font-semibold", className)}>{value ?? "—"}</span>
    </span>
  );
}

/** Muted pill marking a non-data classification (Earnings / Supply / Speaker…). */
export function ClassificationBadge({ label }: { label: string }) {
  return (
    <span className="mr-1 rounded-sm bg-squawk-blue/10 px-1 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-squawk-blue">
      {label}
    </span>
  );
}
